import audioOutput from './capability/audio_output.svg';
import buttonOff from './capability/button-off.svg';
import buttonOn from './capability/button-on.svg';
import button from './capability/button.svg';
import lockClosed from './capability/lock-closed.svg';
import lockOpen from './capability/lock-open.svg';
import lockMode from './capability/lock_mode.svg';
import locked from './capability/locked.svg';
import mediaInput from './capability/media_input.svg';
import onoff from './capability/onoff.svg';
import playCircleBig from './capability/play-circle-big.svg';
import playPauseBig from './capability/play-pause-big.svg';
import speakerAlbum from './capability/speaker_album.svg';
import speakerArtist from './capability/speaker_artist.svg';
import speakerDuration from './capability/speaker_duration.svg';
import speakerNext from './capability/speaker_next.svg';
import speakerPlay from './capability/speaker_play.svg';
import speakerPlaying from './capability/speaker_playing.svg';
import speakerPosition from './capability/speaker_position.svg';
import speakerPrev from './capability/speaker_prev.svg';
import speakerRepeat from './capability/speaker_repeat.svg';
import speakerRepeatList from './capability/speaker_repeat_list.svg';
import speakerShuffle from './capability/speaker_shuffle.svg';
import speakerStop from './capability/speaker_stop.svg';
import speakerTrack from './capability/speaker_track.svg';
import unlocked from './capability/unlocked.svg';
import volumeDown from './capability/volume_down.svg';
import volumeMute from './capability/volume_mute.svg';
import volumeMuteCross from './capability/volume_mute_cross.svg';
import volumeSet from './capability/volume_set.svg';
import volumeUp from './capability/volume_up.svg';

export const capability = {
  audioOutput,
  button,
  buttonOff,
  buttonOn,
  lockMode,
  lockClosed,
  lockOpen,
  locked,
  mediaInput,
  onoff,
  playCircleBig,
  playPauseBig,
  speakerAlbum,
  speakerArtist,
  speakerDuration,
  speakerNext,
  speakerPlay,
  speakerPlaying,
  speakerPosition,
  speakerPrev,
  speakerRepeat,
  speakerRepeatList,
  speakerShuffle,
  speakerStop,
  speakerTrack,
  unlocked,
  volumeDown,
  volumeMute,
  volumeMuteCross,
  volumeSet,
  volumeUp,
} as const;
